/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchTaskStatusEnum } from './BatchTaskStatusEnum';
import {
  BatchTaskStatusEnumFromJSON,
  BatchTaskStatusEnumFromJSONTyped,
  BatchTaskStatusEnumToJSON,
} from './BatchTaskStatusEnum';

/**
 *
 * @export
 * @interface BatchUploadStatus
 */
export interface BatchUploadStatus {
  /**
   *
   * @type {BatchTaskStatusEnum}
   * @memberof BatchUploadStatus
   */
  status: BatchTaskStatusEnum;
  /**
   *
   * @type {string}
   * @memberof BatchUploadStatus
   */
  error?: string | null;
  /**
   *
   * @type {number}
   * @memberof BatchUploadStatus
   */
  progress?: number | null;
}

/**
 * Check if a given object implements the BatchUploadStatus interface.
 */
export function instanceOfBatchUploadStatus(value: object): value is BatchUploadStatus {
  if (!('status' in value) || value['status'] === undefined) return false;
  return true;
}

export function BatchUploadStatusFromJSON(json: any): BatchUploadStatus {
  return BatchUploadStatusFromJSONTyped(json, false);
}

export function BatchUploadStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchUploadStatus {
  if (json == null) {
    return json;
  }
  return {
    status: BatchTaskStatusEnumFromJSON(json['status']),
    error: json['error'] == null ? undefined : json['error'],
    progress: json['progress'] == null ? undefined : json['progress'],
  };
}

export function BatchUploadStatusToJSON(value?: BatchUploadStatus | null): any {
  if (value == null) {
    return value;
  }
  return {
    status: BatchTaskStatusEnumToJSON(value['status']),
    error: value['error'],
    progress: value['progress'],
  };
}
